import { Tab } from 'bootstrap'

const additionalSets = document.querySelectorAll('.js--additional_set');
const showMoreButtons = document.querySelectorAll('.js--show_more_additional');
const anchor = document.querySelector('.js--additional_anchor');
const scrollable = document.querySelector('.js--scrollable');

if (scrollable) {
  scrollable.addEventListener('wheel', function (e) {
    e.preventDefault();
    this.scrollLeft += e.deltaY;
  }, { passive: false })
}

if (additionalSets) {
  additionalSets.forEach((item) => {
    item.style.setProperty('--set-color', item.getAttribute('data-color'));
    item.style.setProperty('--set-top-header-color', item.getAttribute('data-top-header-color'));
  });
}


function updateMaxHeight(prosList, btn) {
  const mobileMaxHeight = 112;
  const desktopMaxHeight = 350;

  const isMobile = window.matchMedia('(max-width: 1280px)').matches;
  const maxHeight = isMobile ? mobileMaxHeight : desktopMaxHeight;

  if (prosList && prosList.offsetHeight <= maxHeight && btn) {
    btn.style.display = 'none';
  } else if (!prosList) {
    btn.style.display = 'none';
  } else {
    btn.style.display = 'flex';
  }
}


const tabSelector = '#myTab';
const tabList = document.querySelectorAll(`${tabSelector} li a[data-bs-toggle="tab"]`);
const listLength = tabList.length;
let currentActive;
tabList.forEach((item, index) => {
  item.addEventListener('shown.bs.tab', event => {
    additionalSets.forEach(item => {
      const prosList = item.querySelector('.js--pros_list ul');
      const btn = item.querySelector('.js--show_more_additional');

      updateMaxHeight(prosList, btn);
    });
    if (index === 0) {
      document.querySelector('.additional_sets__nav_arrow--prev').classList.add('disabled');
    } else {
      document.querySelector('.additional_sets__nav_arrow--prev').classList.remove('disabled');
    }
    if (index === listLength - 1) {
      document.querySelector('.additional_sets__nav_arrow--next').classList.add('disabled');
    } else {
      document.querySelector('.additional_sets__nav_arrow--next').classList.remove('disabled');
    }
    item.scrollIntoView({block: "nearest", inline: "center"});
    setTimeout(() => {
      anchor.scrollIntoView();
    }, 300);
  });
});
document.querySelectorAll('.additional_sets__nav_arrow').forEach(navButton => {
  navButton.addEventListener('click', e => {
    e.preventDefault();

    let currentActive;
    tabList.forEach((tab, index) => {
      tab.addEventListener('shown.bs.tab', event => {
        tab.scrollIntoView({block: "nearest", inline: "center"});
        setTimeout(() => {
          anchor.scrollIntoView();
        }, 300);

      });
      if (tab.classList.contains('active')) {
        currentActive = index;
      }
    });

    const showTab = (tab) => {
      const shownTab = new Tab(tab)
      shownTab.show();
      tab.scrollIntoView({block: "nearest", inline: "center"});
      setTimeout(() => {
        anchor.scrollIntoView();
      }, 300)

      // shownTab.scrollIntoView();
    };

    if (navButton.classList.contains('additional_sets__nav_arrow--prev')) {
      if (currentActive !== 0) {
        showTab(tabList[currentActive - 1]);
      } else {
        showTab(tabList[listLength - 1]);
        document.querySelector('.additional_sets__nav_arrow--prev').classList.add('.disabled');
      }
    } else if (navButton.classList.contains('additional_sets__nav_arrow--next')) {
      if (currentActive != listLength - 1) {
        showTab(tabList[currentActive + 1]);
      } else {
        showTab(tabList[0]);
      }
    }
  });
});


function getColumnsCount() {
  const screenWidth = window.innerWidth;
  if (screenWidth >= 1200) {
    return 3;
  } else if (screenWidth >= 768) {
    return 2;
  } else {
    return 1;
  }
}

function openRowSets(clickedButton) {
  const wrapper = clickedButton.closest('.js--additional_sets_wrapper');
  const allItems = wrapper.querySelectorAll('.js--additional_set');
  const columnsCount = getColumnsCount();
  let clickedIndex = Array.from(allItems).indexOf(clickedButton.closest('.js--additional_set'));

  const startIndex = Math.floor(clickedIndex / columnsCount) * columnsCount;
  const endIndex = startIndex + columnsCount;

  for (let i = startIndex; i < endIndex && i < allItems.length; i++) {
    const item = allItems[i];
    const prosList = item.querySelector('.js--pros_list');
    const button = item.querySelector('.js--show_more_additional');

    if (prosList) {
      prosList.classList.toggle('show');
    }
    if (button) {
      button.classList.toggle('less');
      if (button.classList.contains('less')) {
        button.textContent = button.getAttribute('data-less-text');
      } else {
        button.textContent = button.getAttribute('data-more-text');
      }
    }
  }
}

showMoreButtons.forEach((btn) => {
  btn.addEventListener('click', function (e) {
    if (window.innerWidth >= 1200) {
      openRowSets(this);
    } else {
      const targetEl = this.parentElement.previousElementSibling;
      if (targetEl && targetEl.classList.contains('js--pros_list')) {
        targetEl.classList.toggle('show');
      }
      this.classList.toggle('less');
      if (this.classList.contains('less')) {
        this.textContent = this.getAttribute('data-less-text');
      } else {
        this.textContent = this.getAttribute('data-more-text');
      }
    }
  });
});
window.addEventListener('resize', () => {
  additionalSets.forEach(item => {
    const prosList = item.querySelector('.js--pros_list ul');
    const btn = item.querySelector('.js--show_more_additional');

    updateMaxHeight(prosList, btn);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  additionalSets.forEach(item => {
    const prosList = item.querySelector('.js--pros_list ul');
    const btn = item.querySelector('.js--show_more_additional');

    updateMaxHeight(prosList, btn);
  });
});
